// src/Pages/NumberTaxiForSaleOrRentPage/NumberTaxiForSaleOrRentPage.js

import React from "react";
import NumberTaxiForRentOrSaleTable from "../../components/NumberTaxiForRentOrSaleTable/NumberTaxiForRentOrSaleTable";
import "./NumberTaxiForSaleOrRentPage.css";
import ArticlesPreview from "../../components/ArticlesPreviewBlog/ArticlesPreviewBlog";
import InsuranceSummaryHomepage from "../../components/InsuranceSummaryHomepage/InsuranceSummaryHomepage";
import BuyNewTaxiSiderHomePage from "../../components/BuyNewTaxiSiderHomePage/BuyNewTaxiSiderHomePage";
import Yad2ContactForm from '../../components/Yad2ContactForm/Yad2ContactForm';

const NumberTaxiForSaleOrRentPage = () => {
    
  return <div>
    <NumberTaxiForRentOrSaleTable />;
    <div className="PublicRightsArticle_wrapper">
  <h1 className="PublicRightsArticle_title">השקעה בזכויות ציבוריות להשכרה ולמכירה</h1>

  <p className="PublicRightsArticle_intro">
    בעולם המוניות בישראל, זכויות ציבוריות – הידועות גם בתור "מספרים ירוקים" – הן אחד המשאבים הנדירים והיוקרתיים ביותר. מדובר ברישיון רשמי של משרד התחבורה המאפשר הפעלת מונית בפועל. במאמר זה נצלול לעומק המשמעות של רכישת או השכרת זכות ציבורית, ונבחן האם זו השקעה חכמה ומשתלמת בשוק התחבורה של היום.
  </p>

  <h2 className="PublicRightsArticle_sectionTitle">מהי זכות ציבורית?</h2>
  <p className="PublicRightsArticle_paragraph">
    זכות ציבורית היא אישור להפעלת מונית בישראל. לא ניתן להפעיל מונית ללא מספר ציבורי פעיל, והוא מוצמד לרכב ונהג על ידי רישוי ממשלתי. מספר זה אינו סתם קוד – אלא נכס בעל ערך ממשי, שלעיתים שווה מאות אלפי שקלים. ישנן שתי דרכים עיקריות לנצל את הזכות: בעלות מלאה (רכישה) או שכירות חודשית.
  </p>

  <h3 className="PublicRightsArticle_subSectionTitle">רכישת זכות ציבורית</h3>
  <p className="PublicRightsArticle_paragraph">
    רכישת זכות ציבורית מאפשרת שליטה מלאה – אתה הבעלים, ואתה מחליט אם להפעיל את המונית בעצמך או להשכירה לאחרים. זוהי השקעה לטווח ארוך, שיכולה להניב החזר חודשי על ידי השכרה. בנוסף, ניתן למכור את הזכות בעתיד, לעיתים במחיר גבוה יותר (תלוי בביקוש בשוק).
  </p>

  <h3 className="PublicRightsArticle_subSectionTitle">השכרת זכות ציבורית</h3>
  <p className="PublicRightsArticle_paragraph">
    האפשרות השנייה היא להשכיר זכות – פתרון שמתאים לנהגים שאינם רוצים להשקיע מאות אלפי שקלים, אלא מעוניינים להפעיל מונית באופן מיידי. השכירות נעה סביב תשלום חודשי קבוע, והיא כוללת את אישור המדינה להפעיל את הרכב כמונית. היתרון – כניסה מהירה לעסק. החיסרון – אין בעלות על הנכס.
  </p>

  <h2 className="PublicRightsArticle_sectionTitle">האם זו השקעה טובה?</h2>
  <p className="PublicRightsArticle_paragraph">
    השוק עבר תהפוכות רבות – אפליקציות כמו גט ויאנגו, רגולציות חדשות, ומגמות של מוניות חשמליות – אך הזכויות הציבוריות שומרות על ערכן לאורך זמן. נהגים ותיקים מעדיפים לרכוש, בעוד צעירים רבים שוכרים. הכל תלוי בתקציב, מטרות לטווח ארוך, ואסטרטגיית הפעולה שלך.
  </p>

  <h2 className="PublicRightsArticle_sectionTitle">יתרונות ההשקעה</h2>
  <ul className="PublicRightsArticle_list">
    <li>נכס מניב – ניתן להשכיר ולהרוויח הכנסה חודשית</li>
    <li>ביקוש קבוע – תמיד יש צורך במוניות</li>
    <li>שליטה מלאה – במיוחד אם אתה הבעלים</li>
    <li>אפשרות מכירה עתידית – שווי שעשוי לעלות</li>
  </ul>

  <h2 className="PublicRightsArticle_sectionTitle">דברים שצריך לבדוק לפני</h2>
  <p className="PublicRightsArticle_paragraph">
    לפני שאתה קונה או שוכר זכות, בדוק היטב את תנאי ההסכם, מתי אושרה הזכות, מי עומד מאחוריה, האם יש עליה עיקולים, ומה היסטוריית ההפעלה שלה. בנוסף, חשוב להבין האם הרכב מגיע עם הזכות או בנפרד.
  </p>

  <h2 className="PublicRightsArticle_sectionTitle">סיכום</h2>
  <p className="PublicRightsArticle_paragraph">
    זכות ציבורית היא הרבה מעבר לרישיון – היא קרש קפיצה לעסק עצמאי, ליציבות כלכלית ולעתיד בטוח יותר. בין אם אתה נהג חדש שמחפש לעלות על הכביש במהירות, ובין אם אתה משקיע שמחפש אפיק הכנסה נוסף – השקעה בזכות ציבורית בהחלט יכולה להשתלם. כמו כל השקעה, חשוב לגשת לנושא בעיניים פתוחות, עם ידע, סבלנות, וייעוץ מקצועי נכון.
  </p>
</div>
        {/* טופס פנייה */}
        <div className='AllTaxiYad2ForSalePage-form'>
          <Yad2ContactForm />
        </div>
                <div className="InsuranceSummaryHomepage">
  <InsuranceSummaryHomepage />
</div>
<div className="BuyNewTaxiSiderHomePageHomepage">
  <BuyNewTaxiSiderHomePage />
</div>
                <div className="ArticlesPreviewHomePage">
  <ArticlesPreview />
</div>

    </div>
  
};

export default NumberTaxiForSaleOrRentPage;
